import AssessmentsListingScreen from "app/features/assessments/screens/AssessmentsListingScreen";

export default function AssessmentsPage() {
  return <AssessmentsListingScreen />;
}
